"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const redux_thunk_1 = require("redux-thunk");
const regist_1 = require("../regist");
const redux_1 = require("redux");
const createAppStore = () => {
    // Create combined reducer from all reducers in ReducerRegistry.
    const reducer = regist_1.ReducerRegistry.combineReducers();
    const middleware = regist_1.MiddlewareRegistry.applyMiddleware(redux_thunk_1.thunk);
    const composeEnhancers = redux_1.compose;
    const store = (0, redux_1.legacy_createStore)(reducer, composeEnhancers(middleware));
    regist_1.StateListenerRegistry.subscribe(store);
    if (typeof APP !== 'undefined') {
        APP.store = store;
    }
    return store;
};
exports.default = createAppStore;
